import React, { useEffect, useState } from 'react';
import AddressWrapped from '../AddressWrapped';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import RadioButtonList from '../radioButtonList/RadioButtonList';
import { Add } from '@material-ui/icons';
import ErrorMsg from '../error/ErrorMsg';
import InfoIcon from '../../../assets/images/info.svg';

const Question1 = props => {
  const [duplicateAddressFlag, setDuplicateAddressFlag] = useState(false);

  const setExtraAddress = (address, i) => {
    const addressList = [...props.extraPropertyAddress];
    addressList[i] = address;
    props.setExtraPropertyAddress([...addressList]);
  };

  const deleteExtraAddress = i => {
    const addressList = [...props.extraPropertyAddress];
    addressList[i] = null;
    props.setExtraPropertyAddress([...addressList]);
  };

  const isAddressValid = () => {
    return props.currentAddress?.lookupValue || props.currentAddress?.addressLine;
  };

  useEffect(() => {
    setDuplicateAddressFlag(checkForDuplicateAddresses(props.extraPropertyAddress || []));
  }, [props.extraPropertyAddress, props.currentAddress]);

  const checkForDuplicateAddresses = ownedPropertyAddresses => {
    let isAddressesDuplicated = false;
    const otherIsOwnedPropertyAddressesDuplicated = [];

    let duplicateLookup = {};

    [...ownedPropertyAddresses, ...[props.currentAddress]].forEach((item, index) => {
      if (item) {
        if (Object.keys(item).length > 0) {
          if (!item.enterManually && item.lookupValue?.id) {
            duplicateLookup[item.lookupValue.id] = duplicateLookup[item.lookupValue.id] || [];
            duplicateLookup[item.lookupValue.id].push(index);
          }
        }
      }
    });

    for (const property in duplicateLookup) {
      duplicateLookup[property].forEach(indexTracker => {
        if (duplicateLookup[property].length > 1) {
          otherIsOwnedPropertyAddressesDuplicated[indexTracker] = true;
          isAddressesDuplicated = true;
        } else {
          otherIsOwnedPropertyAddressesDuplicated[indexTracker] = false;
        }
      });
    }
    return isAddressesDuplicated;
  };

  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <h3 className={`${styles.pageTitle}`}>What was this person’s last residential address?</h3>
        <p className={styles.questionText}>
          <img src={InfoIcon} className={styles.infoIcon} alt="info icon" />
          This information will help organisations locate any accounts the person held.
        </p>
        <div className={styles.addressWrapper}>
          <AddressWrapped
            autoValidate
            label={' '}
            placeholder={' '}
            baseUrl={`${process.env.REACT_APP_BASE_URL}/addresssearch`}
            onChange={data => {
              props.selectNursingHome(props.iniNursingHome);
              props.setCurrentAddress(data.address);
            }}
            value={props.currentAddress ?? {}}
            onValidationChange={props.setIsAddressValid}
            onWarningChange={props.setWarnPartialMatch}
            onLoading={props.setAddressValidating}
          />
        </div>
        <h4 className={styles.nswFormLabel}>Did they own the property?</h4>
        <fieldset className={`nsw-form-fieldset ${styles.nswFormFieldset}`}>
          <RadioButtonList
            list={[
              {
                value: '2',
                label: 'Yes',
                checked: props.ownHome && props.ownHome.value === '2' ? true : false,
              },
              {
                value: '1',
                label: 'No',
                checked: props.ownHome && props.ownHome.value === '1' ? true : false,
              },
              {
                value: '0',
                label: 'Unsure',
                checked: props.ownHome && props.ownHome.value === '0' ? true : false,
              },
            ]}
            id={'deceasedOwnHome'}
            name={'deceasedOwnHome'}
            displayLayout={'horizontal'}
            className={`nsw-form-radio__input ${styles.nswFormRadio__input}`}
            handleChange={(item, name) => {
              props.setOwnHome(item);
            }}
          />
        </fieldset>
        <div className={'mb-5'}></div>
        <h3 className={`${styles.pageTitle} mt-5`}>
          Did they own any other property in Australia?
        </h3>
        <p className={styles.questionText}>Leave blank if unknown.</p>
        {props.extraPropertyAddress.map((v, i) => (
          <div className={`pt-3 mt-3 d-flex align-items-baseline ${styles.mobileRow}`}>
            <div className={`${styles.width95} mr-3`} translate="no">
              <AddressWrapped
                autoValidate
                label={' '}
                placeholder={' '}
                baseUrl={`${process.env.REACT_APP_BASE_URL}/addresssearch`}
                onChange={data => {
                  if (!data?.addressLine && !data?.lookupValue) {
                    deleteExtraAddress(i);
                  }
                  if (data?.address?.lookupValue) {
                    setExtraAddress(data.address, i);
                  }
                  if (data?.address?.addressValidationResult && data?.address?.enterManually) {
                    setExtraAddress(data.address, i);
                  }
                }}
                value={props.extraPropertyAddress[i] ?? {}}
                onDetailsRetrieved={data => console.log('onDetailsRetrieved', data)}
                onManualChange={isManual => console.log('manual: ', isManual)}
              />
            </div>
          </div>
        ))}
        {duplicateAddressFlag ? (
          <ErrorMsg
            type={'error'}
            description={
              'The address is a duplicated entry, please either amend the address or remove the address.'
            }
          />
        ) : null}
        {[...props.extraPropertyAddress][props.extraPropertyAddress.length - 1] !== null &&
        !duplicateAddressFlag ? (
          <span className={`${styles.link} mt-5`}>
            <Add className={`pr-2`} />{' '}
            <a onClick={() => props.setExtraPropertyAddress([...props.extraPropertyAddress, {}])}>
              another address
            </a>
          </span>
        ) : null}

        <div className={styles.btnWrap}>
          <Button
            disabled={!props?.ownHome?.label || !isAddressValid() || duplicateAddressFlag}
            onClick={() => {
              props.setCurrentQuestion(2);
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question1;
